export default __webpack_public_path__ + "static/media/mobile-interface-screen.a1079c83.svg";